import styled from 'styled-components';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

const DefaultBox = styled.div`
    max-height: 636px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 70px 19px;
    margin: 0 auto;
    color: ${props => props.theme.colors.textLight};
    background-color: ${props => props.theme.colors.background};
`;

const PcBox = DefaultBox;

const MobileBox = styled(DefaultBox)`
    padding: 30px 6px 18px;

    @media ${({theme}) => theme.mediaQuery.xs} {
        width: 100%;
        padding: 30px 12px 18px;
    }
`;

export const GamePopupDefaultBox = styledByDevice(PcBox, MobileBox);